const Message = (
    <path d="m9 1c-4.411 0-8 3.589-8 8 0 1.44.388 2.789 1.057 3.958l-1.018 3.055c-.09.27-.02.567.181.768.143.143.334.22.53.22.08 0 .16-.013.237-.039l3.055-1.018c1.169.669 2.518 1.057 3.958 1.057 4.411 0 8-3.589 8-8s-3.589-8.001-8-8.001z" />
);

export { Message };
